/**
 * @flow
 * @relayHash febcb2f3855f28263e40da80ed7a8ba6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getAttendeesOverviewQueryVariables = {|
  orgId: string,
  propertyId?: ?string,
  startAt: string,
  endAt: string,
|};
export type getAttendeesOverviewQueryResponse = {|
  +attendeesOverview: {|
    +attendedCount: ?number,
    +brokersCount: ?number,
    +hyeventsCount: ?number,
    +id: string,
    +notAttendedCount: ?number,
    +propertiesCount: ?number,
    +prospectsCount: ?number,
    +residentsCount: ?number,
    +rsvpsCount: ?number,
  |}
|};
export type getAttendeesOverviewQuery = {|
  variables: getAttendeesOverviewQueryVariables,
  response: getAttendeesOverviewQueryResponse,
|};
*/


/*
query getAttendeesOverviewQuery(
  $orgId: ID!
  $propertyId: ID
  $startAt: String!
  $endAt: String!
) {
  attendeesOverview(orgId: $orgId, propertyId: $propertyId, startAt: $startAt, endAt: $endAt) {
    attendedCount
    brokersCount
    hyeventsCount
    id
    notAttendedCount
    propertiesCount
    prospectsCount
    residentsCount
    rsvpsCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startAt",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endAt",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "attendeesOverview",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endAt",
        "variableName": "endAt"
      },
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      },
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      },
      {
        "kind": "Variable",
        "name": "startAt",
        "variableName": "startAt"
      }
    ],
    "concreteType": "OverviewStat",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "attendedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "brokersCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hyeventsCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "notAttendedCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "propertiesCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "prospectsCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "residentsCount",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "rsvpsCount",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getAttendeesOverviewQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getAttendeesOverviewQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getAttendeesOverviewQuery",
    "id": null,
    "text": "query getAttendeesOverviewQuery(\n  $orgId: ID!\n  $propertyId: ID\n  $startAt: String!\n  $endAt: String!\n) {\n  attendeesOverview(orgId: $orgId, propertyId: $propertyId, startAt: $startAt, endAt: $endAt) {\n    attendedCount\n    brokersCount\n    hyeventsCount\n    id\n    notAttendedCount\n    propertiesCount\n    prospectsCount\n    residentsCount\n    rsvpsCount\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a933aec3eeb38d4a72225f47de36fe11';
module.exports = node;
